import Vue from 'vue'
import VueRouter from 'vue-router'
import BlogDetailsPage from '../views/BlogDetailsPage'
import BlogCategoryPosts from '../components/blog/BlogCategoryPosts'
import BlogTagPosts from '../components/blog/BlogTagPosts'
import ContactPage from '../views/ContactPage'
import ErrorPage from '../views/404'
import Homepage from '../views/Home/Homepage.vue'
import Implementation from '../views/Home/Implementation.vue'
import Blog from '../views/Home/Blog.vue'
import Aboutnew from '../views/Home/About.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import TermsAndCondition from '../views/TermsAndCondition.vue'

Vue.use(VueRouter)

// Template demos stay in source for reference and are not public routes.
const routes = [
  {
    path: '/blog-details/:id',
    name: 'Blog details',
    component: BlogDetailsPage,
    meta: {
      title: 'Blog Details | Hubthings'
    }
  },
  {
    path: '/category/:slug',
    name: 'Blog Category List',
    component: BlogCategoryPosts,
    meta: {
      title: 'Blog Category List | Hubthings'
    }
  },
  {
    path: '/tag/:slug',
    name: 'Blog Tag List',
    component: BlogTagPosts,
    meta: {
      title: 'Blog Tag List | Hubthings'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
    meta: {
      title: 'Hubthings l Contact '
    }
  },
  {
    path: '/',
    name: 'Homepage',
    component: Homepage,
    meta: {
      title: 'Hubthings l Home',
      description:
        'Welcome to Hubthings. We provide advanced EV roaming and implementation solutions.',
      keywords: 'EV roaming, Hubthings home, EV solutions'
    }
  },
  {
    path: '/PlanandPricing',
    redirect: '/'
  },
  {
    path: '/Package',
    redirect: '/'
  },
  {
    path: '/Implementation',
    name: 'Implementation',
    component: Implementation,
    meta: {
      title: 'Hubthings l Implementation',
      description:
        'Learn about our implementation process for seamless EV charging network integration.',
      keywords: 'EV implementation, Hubthings integration'
    }
  },
  {
    path: '/Tripplaner',
    redirect: '/'
  },
  {
    path: '/Blog',
    name: 'Blog',
    component: Blog,
    meta: {
      title: 'Hubthings l Blog',
      description:
        'Read the latest news and updates on EV roaming and charging technology from Hubthings.',
      keywords: 'Hubthings blog, EV news, EV charging updates'
    }
  },
  {
    path: '/Aboutnew',
    name: 'Aboutnew',
    component: Aboutnew,
    meta: {
      title: 'Hubthings l About Us',
      description:
        'Learn more about Hubthings, our mission, and our team dedicated to advancing EV roaming.',
      keywords: 'About Hubthings, EV roaming company'
    }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: 'Hubthings l Privacy Policy'
    }
  },
  {
    path: '/terms-condition',
    name: 'TermsAndCondition',
    component: TermsAndCondition,
    meta: {
      title: 'Hubthings l Terms And Condition'
    }
  },
  {
    path: '/error',
    name: 'Error',
    component: ErrorPage,
    meta: { title: 'Hubthings l 404', robots: 'noindex, nofollow' }
  },
  {
    path: '*',
    component: ErrorPage,
    meta: { title: 'Hubthings l 404', robots: 'noindex, nofollow' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // 1. Title
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 2. Meta Description
  if (to.meta.description) {
    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.content = to.meta.description
    } else {
      metaDescription = document.createElement('meta')
      metaDescription.name = 'description'
      metaDescription.content = to.meta.description
      document.head.appendChild(metaDescription)
    }
  }

  // 3. Meta Keywords
  if (to.meta.keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.content = to.meta.keywords
    } else {
      metaKeywords = document.createElement('meta')
      metaKeywords.name = 'keywords'
      metaKeywords.content = to.meta.keywords
      document.head.appendChild(metaKeywords)
    }
  }

  // 4. Canonical Link
  let canonicalLink = document.querySelector('link[rel="canonical"]')
  const origin = window.location.origin || 'https://evroaming.io'
  const canonicalUrl = `${origin}${to.path}`
  if (canonicalLink) {
    canonicalLink.setAttribute('href', canonicalUrl)
  } else {
    canonicalLink = document.createElement('link')
    canonicalLink.setAttribute('rel', 'canonical')
    canonicalLink.setAttribute('href', canonicalUrl)
    document.head.appendChild(canonicalLink)
  }

  // 5. Robots Tag
  let metaRobots = document.querySelector('meta[name="robots"]')
  const robotsVal = to.meta.robots || 'index, follow'
  if (metaRobots) {
    metaRobots.setAttribute('content', robotsVal)
  } else {
    metaRobots = document.createElement('meta')
    metaRobots.setAttribute('name', 'robots')
    metaRobots.setAttribute('content', robotsVal)
    document.head.appendChild(metaRobots)
  }

  next()
  window.scrollTo(0, 0)
})

export default router
